<div
  class="flex flex-col h-full"
  [ngClass]="{ 'md:flex-row': !forceMobileLayout }"
>
  <app-preview-topbar
    [ngClass]="{ 'md:hidden': !forceMobileLayout }"
    [forceMobileLayout]="forceMobileLayout"
    [languages]="languages"
    [selectedLanguage]="state.selectedLanguage"
    [questions]="questions"
    [availablePages]="availablePages"
    [isMenuOpen]="isMobileMenuOpen"
    [previewMode]="state.mode"
    [rulesInText]="state.rulesInText"
    (languageChange)="handleLanguageChange($event)"
    (goToChange)="handleGoToChange($event)"
    (rulesInTextChange)="handleRulesInTextChange($event)"
    (menuToggle)="handleMenuToggle()"
  />
  <div class="min-w-max">
    <app-preview-sidebar
      [class.force-mobile-layout]="forceMobileLayout"
      [forceMobileLayout]="forceMobileLayout"
      [isMenuOpen]="isMobileMenuOpen"
      (deviceChange)="handleDeviceChange($event)"
      (languageChange)="handleLanguageChange($event)"
      (rulesInTextChange)="handleRulesInTextChange($event)"
      [useRules]="state.evalRules"
      (useRulesChange)="handleUseRulesChange($event)"
      (goToChange)="handleGoToChange($event)"
      (print)="triggerPrint()"
      (menuToggle)="handleMenuToggle()"
      [rulesInText]="state.rulesInText"
      [selectedLanguage]="state.selectedLanguage"
      [availablePages]="availablePages"
      [questions]="questions"
      [languages]="languages"
      (previewModeChange)="handlePreviewModeChange($event)"
      [previewMode]="state.mode"
    />
  </div>
  <div class="flex flex-1 flex-col w-full min-h-0">
    <app-preview-header
      class="hidden"
      [ngClass]="{ 'md:block': !forceMobileLayout }"
      [previewMode]="state.mode"
    />
    <iframe
      #previewiframe
      (load)="onIframeLoad($event)"
      class="w-full flex-1"
      [src]="iframeUrl"
    ></iframe>
    <iframe
      #printiframe
      class="invisible absolute top-[-9999px] left-[-9999px] h-auto w-full"
    ></iframe>
  </div>
</div>
